/**
 * CityPro Delivery Partner Registration — mobile-first sign-up.
 * Adds delivery_partner role + vehicle_type + city to citypro_profiles.
 */
import React, { useState } from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

const VEHICLES = [
  { id: 'bike',    label: '🏍️ Bike',    hint: 'Fastest for city' },
  { id: 'scooter', label: '🛵 Scooter', hint: 'Balanced range' },
  { id: 'cycle',   label: '🚲 Cycle',   hint: '0-fuel eco' },
  { id: 'car',     label: '🚗 Car',     hint: 'Bulk / rain-proof' },
  { id: 'van',     label: '🚐 Van',     hint: 'Bulk orders' },
  { id: 'foot',    label: '🚶 Foot',    hint: 'Local street runs' },
];

export default function CityProDeliveryRegister() {
  const [vehicle, setVehicle] = useState('bike');
  const [city, setCity] = useState('');
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const captureLoc = () => new Promise((res) => {
    if (!navigator.geolocation) return res(null);
    navigator.geolocation.getCurrentPosition(
      (p) => res({ latitude: p.coords.latitude, longitude: p.coords.longitude }),
      () => res(null),
      { enableHighAccuracy: true, timeout: 5000 },
    );
  });

  const submit = async () => {
    if (!city.trim()) { toast.error('City bharo'); return; }
    setBusy(true);
    try {
      const loc = await captureLoc();
      await api.post('/citypro/delivery/register', {
        vehicle_type: vehicle, city: city.trim(),
        phone: phone.trim() || undefined,
        latitude: loc?.latitude, longitude: loc?.longitude,
      });
      toast.success('✅ Ho gaya! Aap ab delivery partner ho.');
      nav('/citypro/delivery');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Registration failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-emerald-950/40 to-slate-950 text-white p-3" data-testid="delivery-register-root">
      <div className="max-w-md mx-auto space-y-4 pt-4">
        <div className="text-center">
          <div className="text-3xl mb-1">🛵</div>
          <div className="text-2xl font-black bg-gradient-to-r from-emerald-300 to-cyan-300 bg-clip-text text-transparent">Delivery Partner Signup</div>
          <div className="text-xs opacity-70 mt-1">Har delivery par AT payout milega. Merchant assign karega, aap ek tap me deliver mark karo.</div>
        </div>

        <div className="rounded-2xl border-2 border-emerald-400/40 bg-slate-900 p-4 space-y-3">
          <div>
            <label className="text-[10px] uppercase tracking-widest opacity-70">Vehicle Type</label>
            <div className="grid grid-cols-3 gap-2 mt-1">
              {VEHICLES.map((v) => (
                <button key={v.id} onClick={() => setVehicle(v.id)} data-testid={`delivery-vehicle-${v.id}`}
                        className={`p-2 rounded-xl border-2 text-xs font-black transition ${vehicle === v.id ? 'border-emerald-300 bg-emerald-500/20' : 'border-slate-700 bg-slate-800/60'}`}>
                  <div>{v.label}</div>
                  <div className="text-[9px] opacity-70">{v.hint}</div>
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest opacity-70">City</label>
            <input value={city} onChange={(e) => setCity(e.target.value)} data-testid="delivery-city"
                   placeholder="e.g. Nagpur, Pune, Mumbai"
                   className="w-full mt-1 px-3 py-2.5 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest opacity-70">WhatsApp (optional)</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="delivery-phone"
                   placeholder="10-digit number"
                   className="w-full mt-1 px-3 py-2.5 rounded-lg bg-slate-800 border border-slate-700 text-sm" />
          </div>
          <button onClick={submit} disabled={busy || !city.trim()} data-testid="delivery-register-submit"
                  className="w-full py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-500 text-slate-900 text-sm font-black disabled:opacity-50">
            {busy ? '⏳ Register kar rahe...' : '🚀 Register as Delivery Partner'}
          </button>
          <div className="text-[9px] opacity-70 text-center">
            📍 Registering se aapka current location bhi save hoga (nearby merchants ko aap dikhoge).
          </div>
        </div>
      </div>
    </div>
  );
}
